// Eventos de exemplo do calendario.
//
// O que o painel mostra saiu daqui e passou a vir de `painel_da_conta()`
// (migration 0015): estatisticas, alertas e atividade recente eram numeros
// fixos que nao correspondiam a cadastro nenhum. O que resta e o fallback do
// calendario, usado so quando a consulta a `eventos` falha.

export type CalendarEvent = {
  /**
   * Identificador da agenda, e nao de uma tabela: `evento:12`, `reuniao:<uuid>`.
   *
   * A agenda soma duas origens (`vw_agenda`, migration 0053), e um id numerico
   * de `eventos` colidiria com o de uma reuniao no mesmo dia.
   */
  id: string;
  title: string;
  condo: string;
  date: string;
  time: string;
  type: 'manutencao' | 'mudanca' | 'vistoria' | 'reuniao' | 'alvara' | 'outros';
  condominio_id?: string;
  /** De onde a linha veio. Reuniao e leitura: quem edita e a aba do condominio. */
  origem?: 'evento' | 'reuniao';
};

export const dashboardEvents: CalendarEvent[] = [
  {
    id: '1',
    title: 'Reunião de condomínio - Prestação de contas',
    condo: 'Casa',
    date: '2026-07-21',
    time: '19:00',
    type: 'reuniao',
  },
  {
    id: '2',
    title: 'Coleta de lixo reciclável',
    condo: 'Galhetas',
    date: '2026-07-21',
    time: '08:00',
    type: 'outros',
  },
  {
    id: '3',
    title: 'Vistoria do Corpo de Bombeiros',
    condo: 'Residencial das Palmeiras',
    date: '2026-07-21',
    time: '14:00',
    type: 'vistoria',
  },
  {
    id: '4',
    title: 'Manutenção preventiva - Elevador Torre B',
    condo: 'Galhetas',
    date: '2026-07-22',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '5',
    title: 'Mudança - Apto 304',
    condo: 'Casa',
    date: '2026-07-22',
    time: '10:00',
    type: 'mudanca',
  },
  {
    id: '6',
    title: 'Dedetização geral',
    condo: 'Casa',
    date: '2026-07-23',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '7',
    title: 'Treinamento de brigada de incêndio',
    condo: 'Residencial das Palmeiras',
    date: '2026-07-23',
    time: '14:00',
    type: 'outros',
  },
  {
    id: '8',
    title: "Limpeza de caixa d'água",
    condo: 'Galhetas',
    date: '2026-07-24',
    time: '07:00',
    type: 'manutencao',
  },
  {
    id: '9',
    title: 'Mudança - Apto 1201',
    condo: 'Edifício Comercial Alpha',
    date: '2026-07-24',
    time: '09:00',
    type: 'mudanca',
  },
  {
    id: '10',
    title: 'Conclusão manutenção - Elevador Torre B',
    condo: 'Galhetas',
    date: '2026-07-25',
    time: '17:00',
    type: 'manutencao',
  },
  {
    id: '11',
    title: 'Vistoria técnica - CFTV',
    condo: 'Casa',
    date: '2026-07-25',
    time: '10:00',
    type: 'vistoria',
  },
  {
    id: '12',
    title: 'Mudança - Apto 602',
    condo: 'Casa',
    date: '2026-07-27',
    time: '14:00',
    type: 'mudanca',
  },
  {
    id: '13',
    title: 'Manutenção preventiva - Gerador',
    condo: 'Casa',
    date: '2026-07-28',
    time: '09:00',
    type: 'manutencao',
  },
  {
    id: '14',
    title: 'Reunião com administradora',
    condo: 'Galhetas',
    date: '2026-07-28',
    time: '15:00',
    type: 'reuniao',
  },
  {
    id: '15',
    title: 'Recarga de extintores',
    condo: 'Residencial das Palmeiras',
    date: '2026-07-29',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '16',
    title: 'Vistoria - Sistema de gás',
    condo: 'Casa',
    date: '2026-07-30',
    time: '13:00',
    type: 'vistoria',
  },
  {
    id: '17',
    title: 'Mudança - Sala 505',
    condo: 'Edifício Comercial Alpha',
    date: '2026-07-30',
    time: '10:00',
    type: 'mudanca',
  },
  {
    id: '18',
    title: 'Manutenção preventiva - Portão',
    condo: 'Galhetas',
    date: '2026-07-31',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '19',
    title: 'Alvará de funcionamento vence',
    condo: 'Edifício Comercial Alpha',
    date: '2026-07-31',
    time: '23:59',
    type: 'alvara',
  },
  {
    id: '20',
    title: 'Manutenção preventiva - Academia',
    condo: 'Casa',
    date: '2026-08-01',
    time: '09:00',
    type: 'manutencao',
  },
  {
    id: '21',
    title: 'Jardinagem e poda de árvores',
    condo: 'Residencial das Palmeiras',
    date: '2026-08-01',
    time: '07:00',
    type: 'outros',
  },
  {
    id: '22',
    title: 'Vistoria - Para-raios',
    condo: 'Galhetas',
    date: '2026-08-04',
    time: '10:00',
    type: 'vistoria',
  },
  {
    id: '23',
    title: 'Manutenção mensal - Elevador Torre A',
    condo: 'Casa',
    date: '2026-08-05',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '24',
    title: 'Mudança - Apto 1503',
    condo: 'Residencial das Palmeiras',
    date: '2026-08-05',
    time: '09:00',
    type: 'mudanca',
  },
  {
    id: '25',
    title: 'Reunião de condomínio - Obras',
    condo: 'Residencial das Palmeiras',
    date: '2026-08-07',
    time: '19:00',
    type: 'reuniao',
  },
  {
    id: '26',
    title: 'Dedetização preventiva',
    condo: 'Edifício Comercial Alpha',
    date: '2026-08-08',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '27',
    title: 'Vistoria - Estrutura da fachada',
    condo: 'Galhetas',
    date: '2026-08-08',
    time: '14:00',
    type: 'vistoria',
  },
  {
    id: '28',
    title: 'Manutenção preventiva - Salão de Festas',
    condo: 'Galhetas',
    date: '2026-08-10',
    time: '09:00',
    type: 'manutencao',
  },
  {
    id: '29',
    title: 'Mudança - Apto 801',
    condo: 'Casa',
    date: '2026-08-12',
    time: '10:00',
    type: 'mudanca',
  },
  {
    id: '30',
    title: "Limpeza de caixa d'água",
    condo: 'Casa',
    date: '2026-08-12',
    time: '07:00',
    type: 'manutencao',
  },
  {
    id: '31',
    title: 'Reunião com prestadores',
    condo: 'Edifício Comercial Alpha',
    date: '2026-08-14',
    time: '16:00',
    type: 'reuniao',
  },
  {
    id: '32',
    title: 'Vistoria - AVCB',
    condo: 'Casa',
    date: '2026-08-14',
    time: '10:00',
    type: 'vistoria',
  },
  {
    id: '33',
    title: 'AVCB Galhetas vence em 15 dias',
    condo: 'Galhetas',
    date: '2026-08-15',
    time: '23:59',
    type: 'alvara',
  },
  {
    id: '34',
    title: 'Manutenção preventiva - CFTV',
    condo: 'Residencial das Palmeiras',
    date: '2026-08-18',
    time: '09:00',
    type: 'manutencao',
  },
  {
    id: '35',
    title: 'Manutenção preventiva - Portão Automático',
    condo: 'Galhetas',
    date: '2026-08-20',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '36',
    title: 'Mudança - Sala 1208',
    condo: 'Edifício Comercial Alpha',
    date: '2026-08-20',
    time: '11:00',
    type: 'mudanca',
  },
  {
    id: '37',
    title: 'Reunião assembleia geral',
    condo: 'Residencial das Palmeiras',
    date: '2026-08-22',
    time: '19:00',
    type: 'reuniao',
  },
  {
    id: '38',
    title: 'Vistoria - Sistema elétrico',
    condo: 'Edifício Comercial Alpha',
    date: '2026-08-25',
    time: '13:00',
    type: 'vistoria',
  },
  {
    id: '39',
    title: 'Treinamento de portaria',
    condo: 'Galhetas',
    date: '2026-08-28',
    time: '14:00',
    type: 'outros',
  },
  {
    id: '40',
    title: 'Manutenção preventiva - Gerador',
    condo: 'Galhetas',
    date: '2026-08-28',
    time: '08:00',
    type: 'manutencao',
  },
  {
    id: '41',
    title: 'Mudança - Apto 201',
    condo: 'Residencial das Palmeiras',
    date: '2026-08-30',
    time: '09:00',
    type: 'mudanca',
  },
];
